module.exports = __webpack_public_path__ + "static/media/Icon.cc37ceb8.svg";